import { AlertTriangle } from "lucide-react";
import { Card, CardContent } from "@bookdental/ui";

type Props = {
  error: { message?: string; data?: { code?: string } | null } | null;
};

/**
 * Consulta que falha nao pode virar tela em branco. Antes, `if (!data) return null`
 * escondia FORBIDDEN e o admin ficava vazio sem explicacao — impossivel de diagnosticar
 * sem abrir o DevTools.
 */
export function ErroConsulta({ error }: Props) {
  const codigo = error?.data?.code;
  const semPermissao = codigo === "FORBIDDEN" || codigo === "UNAUTHORIZED";

  return (
    <Card className="border-red-200 bg-white">
      <CardContent className="flex items-start gap-3 p-5">
        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-red-100 text-red-600">
          <AlertTriangle className="h-4 w-4" />
        </span>
        <div className="min-w-0">
          <p className="font-semibold text-admin-900">
            {semPermissao ? "Sem permissão de administrador" : "Não foi possível carregar"}
          </p>
          <p className="mt-1 text-sm text-admin-700">
            {semPermissao
              ? "Se o acesso foi concedido agora, saia e entre novamente — a sessão atual ainda carrega o papel antigo."
              : (error?.message ?? "Erro desconhecido ao consultar a plataforma.")}
          </p>
          {codigo && <p className="mt-2 text-xs text-admin-700/60">Código: {codigo}</p>}
        </div>
      </CardContent>
    </Card>
  );
}
